/* Quiz Funnel V2 — Maison To Sport
   7-question flow with conditional Q4 (clubs vs countries),
   color picker Q5, size Q6, perso Q7, slide transitions.
   Per-jersey short add-on toggle in results.
   Minified version is generated below; this header is stripped. */
(function () {
  "use strict";

  var ROOT = document.getElementById("qfv2Root");
  if (!ROOT) return;

  var BUNDLE_SIZE = 4;
  var MAX_RESULTS = 10;
  var COMPARE = 69.9;
  var CLUB_LIST = ["psg", "real", "barcelone", "ac-milan", "juventus", "manchester-united", "marseille", "inter-milan", "bayern", "naples"];
  var STYLES = ["concept", "retro", "authentic"];
  var STYLE_LABELS = { concept: "Concept", retro: "Rétro", authentic: "Authentique" };
  var PERSO_LABELS = { basic: "Nom + numéro (+4,99€)", full: "Flocage complet (+5,99€)", none: "Sans personnalisation" };
  var COLOR_HEX = {
    noir: "#1A1A1A", blanc: "#FFFFFF", rouge: "#E63946", bleu: "#1D3557",
    vert: "#2ECC71", jaune: "#F4D35E", orange: "#F27A1A", rose: "#FF6B9D", violet: "#7B2D8E"
  };

  // Screen flow definitions
  // Standard order. Q4 routes conditionally based on Q3 (scope).
  var FLOW_FORWARD = {
    "hero":           "q-occasion",
    "q-occasion":     "q-style",
    "q-style":        "q-scope",
    "q-scope":        function () { return state.scope === "nationale" ? "q-team-national" : "q-team-club"; },
    "q-team-club":    "q-color",
    "q-team-national":"q-color",
    "q-color":        "q-size",
    "q-size":         "q-perso",
    "q-perso":        "loading"
  };

  var QUESTION_INDEX = {
    "q-occasion": 1, "q-style": 2, "q-scope": 3,
    "q-team-club": 4, "q-team-national": 4,
    "q-color": 5, "q-size": 6, "q-perso": 7
  };
  var TOTAL_QUESTIONS = 7;

  var handleMap = {};
  var clubLabels = {};
  var countryMap = {};
  try { handleMap = JSON.parse(document.getElementById("qfv2HandleMap").textContent); } catch (e) {}
  try { clubLabels = JSON.parse(document.getElementById("qfv2ClubLabels").textContent); } catch (e) {}
  try { countryMap = JSON.parse(document.getElementById("qfv2CountryMap").textContent); } catch (e) {}

  var productCache = {};
  var cartItemsByHandle = {};
  var cart = null;
  var resultProducts = [];

  var state = {
    occasion: null,
    style: null,
    scope: null,    // "nationale" | "club"
    team: null,     // club slug
    country: null,  // country slug
    color: null,
    size: "L",
    perso: "none"
  };

  // ===== SCREEN MANAGEMENT =====
  var screens = ROOT.querySelectorAll(".qfv2-screen");
  var currentScreen = "hero";

  function setRootStateClass() {
    ROOT.classList.toggle("is-hero", currentScreen === "hero");
    ROOT.classList.toggle("is-quiz", currentScreen !== "hero" && currentScreen !== "loading" && currentScreen !== "result");
    ROOT.classList.toggle("is-result", currentScreen === "result");
  }

  function showScreen(name, isBack) {
    if (currentScreen === name) return;
    var current = ROOT.querySelector('.qfv2-screen[data-screen="' + currentScreen + '"]');
    var next = ROOT.querySelector('.qfv2-screen[data-screen="' + name + '"]');
    if (!next) return;

    // Animate out current
    if (current) {
      current.classList.remove("is-active", "is-back-anim");
      current.classList.add("is-leaving");
      setTimeout(function () {
        current.classList.remove("is-leaving");
      }, 320);
    }

    // Activate next
    next.classList.add("is-active");
    if (isBack) next.classList.add("is-back-anim");
    else next.classList.remove("is-back-anim");

    currentScreen = name;
    setRootStateClass();
    updateProgress(name);

    var sticky = document.getElementById("qfv2StickyCta");
    if (sticky) sticky.hidden = name !== "result";

    // Scroll to top of the screen
    try { window.scrollTo({ top: 0, behavior: "instant" }); } catch (e) { window.scrollTo(0, 0); }
  }

  function updateProgress(screen) {
    var progBlock = document.getElementById("qfv2ProgressBlock");
    var fill = document.getElementById("qfv2ProgressFill");
    var label = document.getElementById("qfv2ProgressLabel");
    if (!progBlock || !fill) return;

    var idx = QUESTION_INDEX[screen];
    if (idx) {
      progBlock.hidden = false;
      fill.style.width = (idx / TOTAL_QUESTIONS * 100) + "%";
      if (label) label.textContent = "Question " + idx + " / " + TOTAL_QUESTIONS;
    } else if (screen === "loading" || screen === "result") {
      progBlock.hidden = true;
      fill.style.width = "100%";
    } else {
      progBlock.hidden = true;
      fill.style.width = "0";
    }
  }

  function nextScreen(fromScreen) {
    var rule = FLOW_FORWARD[fromScreen];
    var nxt = typeof rule === "function" ? rule() : rule;
    if (nxt === "loading") {
      runLoading();
    } else if (nxt) {
      showScreen(nxt, false);
    }
  }

  // ===== EVENT HANDLERS =====
  ROOT.querySelectorAll('[data-action="start"]').forEach(function (b) {
    b.addEventListener("click", function () { showScreen("q-occasion", false); });
  });

  ROOT.querySelectorAll('[data-back]').forEach(function (b) {
    b.addEventListener("click", function () { showScreen(b.dataset.back, true); });
  });

  // Color step has dynamic back button (depends on scope choice — back to club or country list)
  ROOT.querySelectorAll('[data-back-dynamic="team"]').forEach(function (b) {
    b.addEventListener("click", function () {
      var back = state.scope === "nationale" ? "q-team-national" : "q-team-club";
      showScreen(back, true);
    });
  });

  // Generic data-q answer buttons
  ROOT.querySelectorAll("[data-q]").forEach(function (el) {
    el.addEventListener("click", function () {
      var q = el.dataset.q;
      var v = el.dataset.value;
      state[q] = v;
      // Visual selection within this question's group only
      ROOT.querySelectorAll('[data-q="' + q + '"]').forEach(function (sib) {
        sib.classList.remove("is-selected");
      });
      el.classList.add("is-selected");
      // Auto-advance after small delay
      setTimeout(function () { nextScreen(currentScreen); }, 240);
    });
  });

  ROOT.querySelectorAll('[data-action="restart"]').forEach(function (b) {
    b.addEventListener("click", function () {
      state = { occasion: null, style: null, scope: null, team: null, country: null, color: null, size: "L", perso: "none" };
      cartItemsByHandle = {};
      ROOT.querySelectorAll(".is-selected").forEach(function (n) { n.classList.remove("is-selected"); });
      showScreen("hero", true);
    });
  });

  ROOT.querySelectorAll('[data-action="goto-cart"]').forEach(function (b) {
    b.addEventListener("click", function () { window.location.href = "/cart?view=quiz-v2"; });
  });
  ROOT.querySelectorAll('[data-action="close-drawer"]').forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });
  // Floating cart icon + sticky preview button explicitly open the drawer
  document.querySelectorAll('[data-action="open-drawer"]').forEach(function (b) {
    b.addEventListener("click", function () { openDrawer(); });
  });

  // ===== LOADING + RESULTS =====
  function runLoading() {
    showScreen("loading", false);
    var fetchPromise = fetchProducts();
    var checks = document.querySelectorAll("#qfv2LoadingChecks li");
    checks.forEach(function (li) { li.classList.remove("is-done"); });
    var i = 0;
    var tick = function () {
      if (i < checks.length) {
        checks[i].classList.add("is-done");
        i++;
        setTimeout(tick, 320);
      } else {
        fetchPromise.then(function () { renderResults(); showScreen("result", false); });
      }
    };
    setTimeout(tick, 220);
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return null;
        var img = (p.images && p.images[0]) || p.featured_image || "";
        return {
          handle: p.handle,
          id: p.id,
          title: p.title,
          price: p.price / 100,
          compare: p.compare_at_price ? p.compare_at_price / 100 : COMPARE,
          image: img.indexOf("//") === 0 ? "https:" + img : img,
          url: p.url || "/products/" + p.handle,
          tags: p.tags || [],
          variants: (p.variants || []).map(function (v) {
            return { id: v.id, title: v.title, option1: v.option1, price: v.price / 100, available: v.available };
          })
        };
      })
      .catch(function () { return null; });
    return productCache[handle];
  }

  function lookupHandle(team, style) {
    if (handleMap[team] && handleMap[team][style]) return handleMap[team][style];
    if (handleMap[team]) {
      for (var i = 0; i < STYLES.length; i++) {
        var h = handleMap[team][STYLES[i]];
        if (h) return h;
      }
    }
    return "";
  }

  // Country search via /search/suggest.json (returns mocked / live products)
  function fetchCountryProducts(country, style, limit) {
    var info = countryMap[country];
    if (!info) return Promise.resolve([]);
    var query = info.search || info.label;
    var url = "/search/suggest.json?q=" + encodeURIComponent(query + " maillot") + "&resources[type]=product&resources[limit]=" + (limit || 6);
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.resources || !j.resources.results || !j.resources.results.products) return [];
        return j.resources.results.products.map(function (p) {
          return {
            handle: p.handle,
            id: p.id,
            title: p.title,
            price: parseFloat(p.price) || 29.9,
            compare: parseFloat(p.compare_at_price_max) || COMPARE,
            image: (p.image || (p.featured_image && p.featured_image.url) || "").replace(/^\/\//, "https://"),
            url: p.url || "/products/" + p.handle,
            tags: [],
            variants: []
          };
        });
      })
      .catch(function () { return []; });
  }

  function fetchSearchProducts(query, limit) {
    if (!query) return Promise.resolve([]);
    var url = "/search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=product&resources[limit]=" + (limit || 6);
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.resources || !j.resources.results || !j.resources.results.products) return [];
        return j.resources.results.products.map(function (p) {
          return {
            handle: p.handle,
            id: p.id,
            title: p.title,
            price: parseFloat(p.price) || 29.9,
            compare: parseFloat(p.compare_at_price_max) || COMPARE,
            image: (p.image || (p.featured_image && p.featured_image.url) || "").replace(/^\/\//, "https://"),
            url: p.url || "/products/" + p.handle,
            tags: [],
            variants: []
          };
        });
      })
      .catch(function () { return []; });
  }

  function fetchProducts() {
    resultProducts = [];
    var promises = [];
    var addedHandles = {};

    // Strategy: by scope
    if (state.scope === "nationale" && state.country) {
      if (state.country === "autre") {
        promises.push(fetchSearchProducts("selection", 6));
      } else {
        promises.push(fetchCountryProducts(state.country, state.style, 6));
      }
    } else {
      // CLUB scope
      var team = state.team;
      var style = state.style || "concept";
      if (team === "surprise" || !team) {
        team = ["psg", "real", "barcelone", "ac-milan", "juventus"][Math.floor(Math.random() * 5)];
      }

      var clubHandles = [];
      function addH(t, s) {
        var h = lookupHandle(t, s);
        if (h && !addedHandles[h]) { addedHandles[h] = true; clubHandles.push(h); }
      }
      // Selected team: chosen style first, then alternates
      addH(team, style);
      STYLES.filter(function (s) { return s !== style; }).forEach(function (s) { addH(team, s); });

      // Other clubs: chosen style first
      var otherClubs = CLUB_LIST.filter(function (c) { return c !== team; });
      otherClubs.forEach(function (c) { addH(c, style); });
      otherClubs.forEach(function (c) {
        STYLES.filter(function (s) { return s !== style; }).forEach(function (s) {
          if (clubHandles.length < MAX_RESULTS + 4) addH(c, s);
        });
      });

      var clubFetches = clubHandles.slice(0, MAX_RESULTS + 4).map(fetchProductByHandle);
      promises.push(Promise.all(clubFetches).then(function (arr) {
        var found = arr.filter(Boolean);
        // FIX 9: fallback to search/suggest if handle map returned too few products
        if (found.length < 4 && team) {
          var label = clubLabels[team] || team;
          return fetchSearchProducts(label + " " + style, 8).then(function (extra) {
            return found.concat(extra || []);
          });
        }
        return found;
      }));
    }

    return Promise.all(promises).then(function (groups) {
      var combined = [];
      var seen = {};
      groups.forEach(function (group) {
        (group || []).forEach(function (p) {
          if (p && !seen[p.handle]) { seen[p.handle] = true; combined.push(p); }
        });
      });

      // Color sort: prioritize products whose title mentions the color
      if (state.color && state.color !== "aucune") {
        var c = state.color;
        var aliases = {
          noir: ["noir", "black"], blanc: ["blanc", "white"], rouge: ["rouge", "red"],
          bleu: ["bleu", "blue", "marine"], vert: ["vert", "green"], jaune: ["jaune", "yellow"],
          orange: ["orange"], rose: ["rose", "pink"], violet: ["violet", "purple"]
        };
        var keywords = aliases[c] || [c];
        combined.sort(function (a, b) {
          var aMatch = keywords.some(function (k) { return (a.title || "").toLowerCase().indexOf(k) !== -1; });
          var bMatch = keywords.some(function (k) { return (b.title || "").toLowerCase().indexOf(k) !== -1; });
          return (bMatch ? 1 : 0) - (aMatch ? 1 : 0);
        });
      }

      resultProducts = combined.slice(0, MAX_RESULTS);
    });
  }

  function fmt(v) { return isFinite(v) ? v.toFixed(2).replace(".", ",") + "€" : "0,00€"; }

  function renderResults() {
    var titleEl = document.getElementById("qfv2ResultTitle");
    var contextLabel = "ta sélection";
    if (state.scope === "nationale" && state.country && state.country !== "autre") {
      contextLabel = countryMap[state.country] ? countryMap[state.country].label : "ton pays";
    } else if (state.team && state.team !== "surprise") {
      contextLabel = clubLabels[state.team] || "ton club";
    }
    var styleLabel = STYLE_LABELS[state.style] || "Sélection";
    titleEl.textContent = "Ta sélection " + contextLabel + " × " + styleLabel;

    var chips = document.getElementById("qfv2ResultChips");
    chips.innerHTML = "";
    [
      state.style ? STYLE_LABELS[state.style] : null,
      state.scope === "nationale" ? "🌍 National" : "⚽ Club",
      contextLabel,
      state.color && state.color !== "aucune" ? "Couleur " + state.color : null,
      "Taille " + state.size,
      state.perso !== "none" ? PERSO_LABELS[state.perso] : null
    ].forEach(function (txt) {
      if (!txt) return;
      var s = document.createElement("span");
      s.className = "qfv2-chip";
      s.textContent = txt;
      chips.appendChild(s);
    });

    var grid = document.getElementById("qfv2Grid");
    grid.innerHTML = "";
    if (!resultProducts.length) {
      grid.innerHTML = '<p style="grid-column:1/-1;text-align:center;color:#6b6b6b;padding:40px 0;">Aucun maillot trouvé. <a href="/collections/all" style="color:#F27A1A;font-weight:700;">Voir tous les maillots →</a></p>';
    } else {
      resultProducts.forEach(function (p) { grid.appendChild(buildProductCard(p)); });
    }
    updateBundleUI();
  }

  function buildProductCard(p) {
    var card = document.createElement("div");
    card.className = "qfv2-card-product";
    card.dataset.handle = p.handle;
    card.innerHTML =
      '<a href="' + p.url + '" target="_blank" rel="noopener" class="qfv2-card-img"><img src="' + p.image + '" alt="' + esc(p.title) + '" loading="lazy" decoding="async"></a>' +
      '<div class="qfv2-card-body">' +
        '<h4 class="qfv2-card-title">' + esc(p.title) + '</h4>' +
        '<div class="qfv2-card-price"><strong>' + fmt(p.price) + '</strong> <s>' + fmt(p.compare) + '</s></div>' +
        '<div class="qfv2-card-controls"></div>' +
        '<div class="qfv2-card-short-row" hidden>' +
          '<label class="qfv2-card-short-toggle">' +
            '<input type="checkbox" class="qfv2-card-short-cb">' +
            '<span class="qfv2-card-short-text"><strong>🩳 + Short assorti</strong> <span class="qfv2-card-short-price">+16,99€</span></span>' +
          '</label>' +
          '<select class="qfv2-card-short-size" aria-label="Taille du short" hidden>' +
            '<option value="S">Taille S</option>' +
            '<option value="M">Taille M</option>' +
            '<option value="L">Taille L</option>' +
            '<option value="XL">Taille XL</option>' +
            '<option value="XXL">Taille XXL</option>' +
          '</select>' +
        '</div>' +
        '<button type="button" class="qfv2-add-btn">Ajouter au panier</button>' +
      '</div>';

    var ctrls = card.querySelector(".qfv2-card-controls");
    var sel = document.createElement("select");
    sel.className = "qfv2-size-select";
    sel.setAttribute("aria-label", "Choisir la taille");
    availableSizes(p).forEach(function (s) {
      var opt = document.createElement("option");
      opt.value = s; opt.textContent = "Taille " + s;
      if (s === state.size) opt.selected = true;
      sel.appendChild(opt);
    });
    ctrls.appendChild(sel);

    // Per-jersey short toggle: probe availability, then reveal
    var shortRow = card.querySelector(".qfv2-card-short-row");
    var shortCb = card.querySelector(".qfv2-card-short-cb");
    var shortSizeSel = card.querySelector(".qfv2-card-short-size");
    if (shortSizeSel) {
      // Default short size mirrors jersey size
      var def = sel.value || state.size;
      Array.prototype.forEach.call(shortSizeSel.options, function (o) { if (o.value === def) o.selected = true; });
    }
    if (shortCb && shortSizeSel) {
      shortCb.addEventListener("change", function () {
        shortSizeSel.hidden = !shortCb.checked;
      });
    }
    // When jersey size changes, sync short size default
    sel.addEventListener("change", function () {
      if (shortSizeSel) {
        Array.prototype.forEach.call(shortSizeSel.options, function (o) { o.selected = (o.value === sel.value); });
      }
    });
    probeShortForJersey(p.handle).then(function (avail) {
      if (avail && shortRow) shortRow.hidden = false;
    });

    var btn = card.querySelector(".qfv2-add-btn");
    btn.addEventListener("click", function () {
      var size = sel.value;
      var addShort = !!(shortCb && shortCb.checked);
      var shortSize = shortSizeSel ? shortSizeSel.value : size;
      // If product was loaded via search/suggest, variants may be empty — fetch full first
      var ensure = (p.variants && p.variants.length) ? Promise.resolve(p) : fetchProductByHandle(p.handle);
      ensure.then(function (full) {
        var product = full || p;
        var variant = pickVariant(product, size);
        if (!variant) { alert("Cette taille est indisponible."); return; }
        addToCart(product, variant, size, btn, card, { addShort: addShort, shortSize: shortSize });
      });
    });
    return card;
  }

  // ===== Per-jersey short probe + add-on (FIX 3) =====
  var shortProductCache = {};
  function deriveShortHandle(maillotHandle) {
    if (!maillotHandle) return null;
    if (maillotHandle.indexOf("maillot-") === 0) return maillotHandle.replace("maillot-", "short-");
    return null;
  }
  function fetchShortProduct(maillotHandle) {
    var h = deriveShortHandle(maillotHandle);
    if (!h) return Promise.resolve(null);
    if (shortProductCache[h]) return shortProductCache[h];
    shortProductCache[h] = fetch("/products/" + h + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return shortProductCache[h];
  }
  function probeShortForJersey(maillotHandle) {
    return fetchShortProduct(maillotHandle).then(function (p) { return !!(p && p.variants && p.variants.length); });
  }
  function pickShortVariant(product, size) {
    if (!product || !product.variants) return null;
    var s = (size || "").trim().toLowerCase();
    if (s) {
      var match = product.variants.find(function (v) {
        var t = (v.option1 || v.title || "").trim().toLowerCase();
        return v.available && (t === s || t.indexOf(s) !== -1);
      });
      if (match) return match;
    }
    return product.variants.find(function (v) { return v.available; }) || null;
  }
  function addShortForJersey(maillotHandle, jerseyKey, shortSize) {
    return fetchShortProduct(maillotHandle).then(function (product) {
      if (!product) return null;
      var variant = pickShortVariant(product, shortSize);
      if (!variant) return null;
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{
            id: parseInt(variant.id, 10),
            quantity: 1,
            properties: {
              "_addon": "short",
              "Taille": variant.title || shortSize,
              "Short assorti": "Oui",
              "_short_for_handle": maillotHandle,
              "_for_key": jerseyKey,
              "_for_handle": maillotHandle,
              "_quiz": "v2"
            }
          }]
        })
      }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    });
  }

  function availableSizes(p) {
    var SIZES = ["S", "M", "L", "XL", "XXL"];
    var found = [];
    if (p.variants && p.variants.length) {
      p.variants.forEach(function (v) {
        SIZES.forEach(function (s) {
          var t = (v.option1 || v.title || "").trim();
          if (found.indexOf(s) === -1 && (t === s || t.indexOf(s + " ") !== -1 || t.indexOf(" " + s) !== -1)) found.push(s);
        });
      });
    }
    return found.length ? found : SIZES;
  }

  function pickVariant(p, size) {
    if (!p.variants || !p.variants.length) return null;
    var v = p.variants.find(function (v) { return (v.option1 || v.title || "").trim() === size; });
    if (!v) v = p.variants.find(function (v) { return (v.option1 || v.title || "").trim().indexOf(size) !== -1; });
    return v || p.variants.find(function (v) { return v.available; }) || p.variants[0];
  }

  function addToCart(product, variant, size, btn, card, opts) {
    opts = opts || {};
    btn.classList.add("is-loading"); btn.disabled = true; btn.textContent = "Ajout…";
    var sid = sessionId();
    var props = {
      _quiz: "v2",
      _quiz_size: size,
      _quiz_team: state.team || "",
      _quiz_country: state.country || "",
      _quiz_style: state.style || "",
      _quiz_color: state.color || "",
      _bundle_group: "quiz-bundle-" + sid
    };
    if (state.perso === "basic") {
      props["Flocage"] = "À personnaliser au panier";
    }
    if (state.perso === "full") {
      props["Flocage"] = "À personnaliser au panier";
      props["Flocage Bas"] = "À personnaliser au panier";
      props["Badge"] = "À choisir au panier";
    }

    var jerseyKey = null;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(variant.id, 10), quantity: 1, properties: props }] })
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function (resp) {
        var item = (resp.items && resp.items[0]) || resp;
        jerseyKey = item.key;
        cartItemsByHandle[product.handle] = { product: product, variant: variant, size: size, key: item.key };
        // Chain short add-on if requested (rate-limit pause for Shopify)
        if (opts.addShort && jerseyKey) {
          return new Promise(function (r) { setTimeout(r, 300); })
            .then(function () { return addShortForJersey(product.handle, jerseyKey, opts.shortSize || size); });
        }
        return null;
      })
      .then(function () {
        btn.classList.remove("is-loading"); btn.disabled = false;
        btn.textContent = "✓ Ajouté"; btn.classList.add("is-added");
        card.classList.add("is-added");
        pushCartAttributes();
        return loadCart();
      })
      .then(function () {
        // FIX 1: replaced openDrawer() with non-blocking toast + UI updates
        showAddedToast(product);
        updateBundleUI();
        updateFabAndSticky();
      })
      .catch(function (e) {
        console.error("[qfv2] add error", e);
        btn.classList.remove("is-loading"); btn.disabled = false;
        btn.textContent = "Ajouter au panier";
        alert("Erreur lors de l'ajout. Réessaie.");
      });
  }

  function pushCartAttributes() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          quiz_funnel: "v2",
          quiz_scope: state.scope || "",
          quiz_team: state.team || "",
          quiz_country: state.country || "",
          quiz_style: state.style || "",
          quiz_size: state.size || "",
          quiz_color: state.color || "",
          quiz_perso: state.perso || "",
          quiz_occasion: state.occasion || "",
          quiz_completed_at: new Date().toISOString()
        }
      })
    });
  }

  function loadCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  function sessionId() {
    var k = "qfv2_session";
    var v = sessionStorage.getItem(k);
    if (!v) { v = Date.now().toString(36) + Math.random().toString(36).slice(2, 6); sessionStorage.setItem(k, v); }
    return v;
  }

  function jerseyCount() {
    if (!cart) return Object.keys(cartItemsByHandle).length;
    return cart.items.filter(function (it) {
      var p = it.properties || {};
      if (p._for_key || p._short_for_handle || p._addon) return false;
      return p._quiz === "v2" && it.product_type !== "Short" && (it.title || "").toLowerCase().indexOf("short") === -1;
    }).reduce(function (a, it) { return a + it.quantity; }, 0);
  }

  function bundleMessage(n) {
    if (n === 0) return "🎁 Ajoute 4 maillots pour avoir le 4ème OFFERT";
    if (n === 1) return "Ajoutes-en 3 de plus pour avoir le 4ème OFFERT";
    if (n === 2) return "Plus que 2 ! 💡 Astuce : code MTSP25 = -25% si tu n'en prends que 2";
    if (n === 3) return "🔥 PLUS QU'UN MAILLOT ! Le prochain est GRATUIT";
    if (n === 4) return "🎉 BRAVO ! Ton 4ème maillot est OFFERT";
    if (n >= 5 && n < 8) return "À 8 maillots = 2 OFFERTS ! Continue.";
    if (n >= 8) return "🔥 Tu as débloqué 2 maillots OFFERTS !";
    return "";
  }

  function updateBundleUI() {
    var n = jerseyCount();
    var msg = bundleMessage(n);
    document.querySelectorAll(".qfv2-progress-dots").forEach(function (cont) {
      cont.querySelectorAll(".qfv2-dot").forEach(function (dot, i) {
        dot.classList.toggle("is-on", i < n);
        if (i === 3 && n >= 4) dot.classList.add("is-gift-on");
      });
    });
    var ptxt = document.getElementById("qfv2ProgressText");
    if (ptxt) ptxt.innerHTML = "Tu as <strong>" + n + "/4</strong> maillots — " + msg;
    var dmsg = document.getElementById("qfv2DrawerMsg");
    if (dmsg) dmsg.textContent = msg;
    var bb = document.getElementById("qfv2BundleMessage");
    if (bb) bb.textContent = msg;
    var sticky = document.getElementById("qfv2StickyCta");
    var stickyCount = document.getElementById("qfv2StickyCount");
    var stickyTotal = document.getElementById("qfv2StickyTotal");
    var stickySav = document.getElementById("qfv2StickySavings");
    if (sticky) sticky.hidden = n === 0 || currentScreen !== "result";
    if (cart) {
      var disc = cart.total_discount / 100;
      if (stickyCount) stickyCount.textContent = n + " maillot" + (n > 1 ? "s" : "");
      if (stickyTotal) stickyTotal.textContent = fmt(cart.total_price / 100);
      if (stickySav) stickySav.textContent = disc > 0 ? " · économise " + fmt(disc) : "";
    }
    if (n === 4 || n === 8) confetti();
  }

  function openDrawer() {
    var d = document.getElementById("qfv2Drawer");
    if (!d) return;
    d.classList.add("is-open");
    d.setAttribute("aria-hidden", "false");
    document.body.classList.add("qfv2-locked");
    renderDrawer();
    updateBundleUI();
  }
  function closeDrawer() {
    var d = document.getElementById("qfv2Drawer");
    if (!d) return;
    d.classList.remove("is-open");
    d.setAttribute("aria-hidden", "true");
    document.body.classList.remove("qfv2-locked");
  }

  function renderDrawer() {
    var box = document.getElementById("qfv2DrawerItems");
    if (!box || !cart) return;
    box.innerHTML = "";
    // Group linked addons (shorts) by their parent _for_key
    var linkedByParent = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._for_key) {
        (linkedByParent[p._for_key] = linkedByParent[p._for_key] || []).push(it);
      }
    });
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._quiz !== "v2") return;
      // Skip linked addons (rendered as sub-row under parent)
      if (p._for_key) return;
      if (p._short_for_handle) return;
      var row = document.createElement("div");
      row.className = "qfv2-drawer-item";
      row.innerHTML =
        '<div class="qfv2-drawer-item-img"><img src="' + (it.image || (it.featured_image && it.featured_image.url) || "") + '" alt="" loading="lazy"></div>' +
        '<div class="qfv2-drawer-item-info">' +
          '<p class="qfv2-drawer-item-title">' + esc(it.product_title || it.title) + '</p>' +
          '<p class="qfv2-drawer-item-meta">' + esc(it.variant_title || "") + ' · ' + fmt(it.line_price / 100) + (it.total_discount > 0 ? ' <span class="qfv2-free-tag">OFFERT</span>' : '') + '</p>' +
        '</div>' +
        '<button type="button" class="qfv2-drawer-item-remove" data-key="' + it.key + '" aria-label="Retirer">✕</button>';
      box.appendChild(row);
      // Render any linked shorts under this jersey
      var linked = linkedByParent[it.key] || [];
      linked.forEach(function (sub) {
        var subProps = sub.properties || {};
        if (!subProps._short_for_handle) return;
        var subRow = document.createElement("div");
        subRow.className = "qfv2-drawer-item qfv2-drawer-item-linked";
        subRow.innerHTML =
          '<div class="qfv2-drawer-item-img"><img src="' + (sub.image || (sub.featured_image && sub.featured_image.url) || "") + '" alt="" loading="lazy"></div>' +
          '<div class="qfv2-drawer-item-info">' +
            '<p class="qfv2-drawer-item-title">↳ Short assorti</p>' +
            '<p class="qfv2-drawer-item-meta">' + esc(sub.variant_title || subProps["Taille"] || "") + ' · ' + fmt(sub.line_price / 100) + '</p>' +
          '</div>' +
          '<button type="button" class="qfv2-drawer-item-remove" data-key="' + sub.key + '" aria-label="Retirer">✕</button>';
        box.appendChild(subRow);
      });
    });
    box.querySelectorAll(".qfv2-drawer-item-remove").forEach(function (b) {
      b.addEventListener("click", function () {
        var key = b.dataset.key;
        // Cascade: collect any linked addons (shorts) that point to this parent
        var linkedKeys = (cart.items || [])
          .filter(function (it) { return (it.properties || {})._for_key === key; })
          .map(function (it) { return it.key; });
        var keysToRemove = [key].concat(linkedKeys);
        var p = Promise.resolve();
        keysToRemove.forEach(function (k) {
          p = p.then(function () {
            return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: k, quantity: 0 }) });
          });
        });
        p.then(loadCart)
          .then(function () {
            var removed = (cart.items || []).every(function (it) { return it.key !== key; });
            if (removed) {
              ROOT.querySelectorAll(".qfv2-card-product.is-added").forEach(function (c) {
                if (cartItemsByHandle[c.dataset.handle] && cartItemsByHandle[c.dataset.handle].key === key) {
                  c.classList.remove("is-added");
                  var ab = c.querySelector(".qfv2-add-btn");
                  if (ab) { ab.textContent = "Ajouter au panier"; ab.classList.remove("is-added"); }
                  delete cartItemsByHandle[c.dataset.handle];
                }
              });
            }
            renderDrawer(); updateBundleUI(); updateFabAndSticky();
          });
      });
    });
    var dt = document.getElementById("qfv2DrawerTotal");
    if (dt) dt.textContent = fmt(cart.total_price / 100);
    var dsav = document.getElementById("qfv2DrawerSavings");
    if (dsav) {
      var s = (cart.items_subtotal_price - cart.total_price) / 100;
      if (s > 0) { dsav.style.display = ""; dsav.textContent = "🔥 Tu économises " + fmt(s); }
      else dsav.style.display = "none";
    }
  }

  // ===== TOAST (FIX 1) =====
  var TOAST_HIDE_TIMER = null;
  function showAddedToast(product) {
    var toast = document.getElementById("qfv2Toast");
    if (!toast) return;
    var img = document.getElementById("qfv2ToastImg");
    var prod = document.getElementById("qfv2ToastProduct");
    if (img) img.src = product.image || "";
    if (prod) prod.textContent = product.title || "";

    // Bundle bar
    var n = jerseyCount(cart);
    var target = n < 4 ? 4 : n < 8 ? 8 : 12;
    var pct = Math.min((n / target) * 100, 100);
    var fill = document.getElementById("qfv2ToastBundleFill");
    if (fill) fill.style.width = pct + "%";
    var bt = document.getElementById("qfv2ToastBundleText");
    if (bt) {
      if (n >= 4 && n < 8) bt.textContent = "🎉 4ème maillot OFFERT débloqué !";
      else if (n >= 8 && n < 12) bt.textContent = "🔥 2 maillots OFFERTS débloqués !";
      else if (n >= 12) bt.textContent = "🎉 3 maillots OFFERTS !";
      else if (target - n === 1) bt.textContent = "🔥 PLUS QU'UN MAILLOT pour le " + target + "ème OFFERT !";
      else bt.textContent = "Plus que " + (target - n) + " maillot" + (target - n > 1 ? "s" : "") + " pour le " + target + "ème OFFERT";
    }

    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add("is-show"); });

    clearTimeout(TOAST_HIDE_TIMER);
    TOAST_HIDE_TIMER = setTimeout(function () {
      toast.classList.remove("is-show");
      setTimeout(function () { toast.hidden = true; }, 320);
    }, 3200);
  }

  function updateFabAndSticky() {
    var fab = document.getElementById("qfv2FabCart");
    var fabCount = document.getElementById("qfv2FabCount");
    if (!fab) return;
    var n = jerseyCount(cart);
    if (n > 0) {
      fab.hidden = false;
      if (fabCount) fabCount.textContent = n;
    } else {
      fab.hidden = true;
    }
  }

  function confetti() {
    var box = document.getElementById("qfv2Confetti");
    if (!box) return;
    box.innerHTML = ""; box.classList.add("is-on");
    var colors = ["#F27A1A", "#16a34a", "#facc15", "#1a1a1a", "#3b82f6"];
    for (var i = 0; i < 70; i++) {
      var s = document.createElement("span");
      s.className = "qfv2-confetti-piece";
      s.style.left = Math.random() * 100 + "%";
      s.style.background = colors[i % colors.length];
      s.style.animationDelay = Math.random() * 0.3 + "s";
      s.style.animationDuration = 1.5 + Math.random() * 1.2 + "s";
      box.appendChild(s);
    }
    setTimeout(function () { box.classList.remove("is-on"); box.innerHTML = ""; }, 3000);
  }

  function esc(s) {
    return (s || "").replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // ===== FIX 4: Navigation safety — prevent unwanted page exits during quiz =====
  // 1. Block any form submit inside the quiz container
  ROOT.querySelectorAll("form").forEach(function (f) {
    f.addEventListener("submit", function (e) { e.preventDefault(); });
  });
  // 2. Force every button to type=button (prevents implicit submit if a stray <form> ancestor exists)
  ROOT.querySelectorAll("button:not([type])").forEach(function (b) { b.type = "button"; });
  // 3. Intercept link clicks inside the quiz (except the explicit cart redirect & external links)
  ROOT.querySelectorAll('a[href]').forEach(function (a) {
    var href = a.getAttribute("href") || "";
    var external = a.target === "_blank";
    var allowed = href.indexOf("/cart") === 0 || href.indexOf("/checkout") === 0 || href.indexOf("https://wa.me") === 0;
    if (!external && !allowed) {
      a.addEventListener("click", function (e) {
        // Only intercept if user is mid-quiz (not on hero, not on result)
        if (currentScreen !== "hero" && currentScreen !== "result") {
          e.preventDefault();
          if (confirm("Sortir du quiz ? Ton avancement sera perdu.")) {
            window.location.href = href;
          }
        }
      });
    }
  });

  // ===== INIT =====
  setRootStateClass();
  updateProgress("hero");
  loadCart().catch(function () {});
})();
